import { memo } from 'react';

const InitialViewIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="487" height="487" fill="none">
    <circle cx="250.5" cy="235.5" r="82.5" fill="#F8B1DC" />
    <rect
      width="104.564"
      height="122.512"
      x="201.326"
      y="175.575"
      fill="#EAECF1"
      rx="20"
    />
    <circle cx="158.017" cy="194.693" r="5.072" fill="#0D3880" />
    <path fill="#fff" d="m157.237 251.267 5.744 9.949h-11.488l5.744-9.949Z" />
    <path
      fill="#051A49"
      d="M276.316 184.768h11.505l-.018-.001h-68.275a9.103 9.103 0 0 0-9.103 9.103v14.739a9.103 9.103 0 0 0 9.103 9.104h68.275a9.103 9.103 0 0 0 9.103-9.104v-3.251c-11.338 0-20.59-9.179-20.59-20.59Z"
    />
    <path
      fill="#E60278"
      d="M287.821 184.768h-11.505c0 11.411 9.252 20.59 20.591 20.59V193.87c0-5.021-4.066-9.092-9.086-9.102Z"
    />
    <path
      fill="#0D3880"
      fillRule="evenodd"
      d="M260.493 202.934v-10.76c5.954 0 10.812 4.815 10.812 10.8h-10.812v-.04Z"
      clipRule="evenodd"
    />
    <path
      fill="#E60278"
      fillRule="evenodd"
      d="M288.67 217.713a10.168 10.168 0 0 0-10.198-10.187c-5.654 0-10.2 4.542-10.2 10.187h6.798a3.409 3.409 0 0 1 3.402-3.395 3.408 3.408 0 0 1 3.399 3.395h6.799Z"
      clipRule="evenodd"
    />
    <path
      fill="#B1BDCF"
      d="M291.676 247.266h-75.032v5.011h75.032v-5.011Zm0-16.029h-75.032v5.011h75.032v-5.011Zm-15.832 37.07h-59.2v-5.011h57.145l2.055 5.011Z"
    />
    <path
      fill="#EAECF1"
      d="M185.115 177.964h-34.687a7.627 7.627 0 0 0-7.627 7.627v43.222a7.628 7.628 0 0 0 7.627 7.628h34.687a7.628 7.628 0 0 0 7.627-7.628v-43.222a7.627 7.627 0 0 0-7.627-7.627Z"
    />
    <path
      fill="#B1BDCF"
      d="M185.601 196.896h-14.944v2.341h14.944v-2.341Zm0-7.627h-14.944v2.341h14.944v-2.341Zm0 28.204h-35.659v2.341h35.659v-2.341Zm0-7.628h-35.659v2.341h35.659v-2.341Zm-2.025 15.255h-31.609v2.341h31.609V225.1Z"
    />
    <path
      fill="#051A49"
      stroke="#000"
      d="m198.786 221.527-.354.353.354.354 6.516 6.516a1.057 1.057 0 0 1 0 1.495l-2.278 2.278a1.058 1.058 0 0 1-1.496 0l-6.515-6.516-.354-.353-.353.353-3.744 3.744a.607.607 0 0 1-.993-.203l-8.04-20.008a.607.607 0 0 1 .79-.79l20.007 8.041a.606.606 0 0 1 .203.992v.001l-3.743 3.743Z"
    />
    <path
      fill="#B1BDCF"
      d="M185.115 239.61h-34.687a7.628 7.628 0 0 0-7.627 7.628v43.221a7.628 7.628 0 0 0 7.627 7.628h34.687a7.628 7.628 0 0 0 7.627-7.628v-43.221a7.628 7.628 0 0 0-7.627-7.628Z"
    />
    <path
      fill="#fff"
      d="M185.601 258.542h-14.944v2.341h14.944v-2.341Zm0-7.627h-14.944v2.341h14.944v-2.341Zm0 28.204h-35.659v2.341h35.659v-2.341Zm0-7.628h-35.659v2.341h35.659v-2.341Zm-2.025 15.255h-31.609v2.341h31.609v-2.341Z"
    />
    <g fill="#F8B1DC" clipPath="url(#a)">
      <path d="m341.865 322.347-11.201-11.201a4.155 4.155 0 1 1 5.877-5.878l11.201 11.201a4.155 4.155 0 0 1 0 5.878 4.154 4.154 0 0 1-5.877 0Zm-11.201-166.343a4.154 4.154 0 0 1 0-5.877l11.2-11.2a4.155 4.155 0 1 1 5.878 5.877l-11.201 11.2a4.154 4.154 0 0 1-5.877 0Z" />
      <path d="m341.865 322.347-11.201-11.201a4.155 4.155 0 1 1 5.877-5.878l11.201 11.201a4.155 4.155 0 0 1 0 5.878 4.154 4.154 0 0 1-5.877 0Zm21.017-88.859a4.033 4.033 0 0 1 2.852-6.884h15.839a4.032 4.032 0 1 1 0 8.065h-15.839a4.02 4.02 0 0 1-2.852-1.181ZM253.18 123.786a4.023 4.023 0 0 1-1.18-2.852v-15.839a4.032 4.032 0 1 1 8.064 0v15.839a4.031 4.031 0 0 1-6.884 2.852Zm-.001 235.244a4.019 4.019 0 0 1-1.18-2.851v-15.841a4.032 4.032 0 1 1 8.065 0l-.001 15.841a4.03 4.03 0 0 1-6.884 2.851Zm77.572-203.113a4.032 4.032 0 0 1 0-5.703l11.2-11.2a4.032 4.032 0 1 1 5.703 5.703l-11.2 11.2a4.032 4.032 0 0 1-5.703 0Z" />
      <path d="m341.952 322.26-11.201-11.201a4.032 4.032 0 1 1 5.703-5.703l11.201 11.201a4.032 4.032 0 1 1-5.703 5.703Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path
          fill="#fff"
          d="M0 0h344.126v344.126H0z"
          transform="rotate(45 121.667 293.73)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default memo(InitialViewIcon);
